import React from 'react';
import { Modal } from '@dropbox/dig-components/modal';
import { Text } from '@dropbox/dig-components/typography';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { getBrandName } from 'signer-app/utils/brand';
import { Button } from '@dropbox/dig-components/buttons';
import styles from 'signer-app/signer-signature-document/signed-data-modal.module.css';

const messages = defineMessages({
  close: {
    id: 'd81cc77529e635a5c8a495e6f24a80ec8748212b76aea670f9ff7a464eb5677a',
    description: 'close modal',
    defaultMessage: 'Close',
  },
});

type Props = {
  onConfirm: () => void;
};

const SignedDataModal: React.FunctionComponent<Props> = ({ onConfirm }) => {
  const [visible, setVisible] = React.useState(true);
  const handleClose = React.useCallback(() => {
    setVisible(false);
  }, []);
  const handleConfirm = React.useCallback(() => {
    handleClose();
    onConfirm();
  }, [handleClose, onConfirm]);
  const intl = useIntl();

  return (
    <Modal
      open={visible}
      isCentered
      width="standard"
      withCloseButton={intl.formatMessage(messages.close)}
      onRequestClose={handleClose}
      shouldCloseOnOverlayClick={false}
      aria-labelledby="signed-data-modal-title"
    >
      <Modal.Header hasBottomSpacing="title-standard">
        <Modal.Title id="signed-data-modal-title">
          <FormattedMessage
            id="8fcc35b044a3f645cd9cb54b39a82e65eae110b9e2c397e52599686722565be2"
            description="Automatically prefill fields? header"
            defaultMessage="Automatically prefill fields?"
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Text tagName="p" className={styles.text}>
          <FormattedMessage
            id="8a74cc84616f91d938cc1b52ee5c219034bd10cee4782dfb0d239125b51a96a5"
            description="Prefill fields disclaimer"
            defaultMessage="To save time, you can prefill fields with what you entered the last time you signed."
          />
        </Text>
        <Text tagName="p" className={styles.text}>
          <FormattedMessage
            id="cfd1266f48f2f33f99032df30834a1c8f96ef86070e37a82f67a2ac4d056acb7"
            description="Prefill fields disclaimer"
            defaultMessage="After fields are prefilled, please review and update them if needed. {brandName} isn’t responsible for any data errors in prefilled fields."
            values={{ brandName: getBrandName('S') }}
          />
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="opacity" onClick={handleClose}>
          <FormattedMessage
            id="d781cebff181627377c64cc7065d1c2cf447b0a69983dc37703794be32f07c26"
            description="Cancel button"
            defaultMessage="Cancel"
          />
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          <FormattedMessage
            id="1bd1bc700decfe46d0f0591b64b85cdd34431075f9cbe191f3c4d1c3b26d0ea6"
            description="Prefill fields button"
            defaultMessage="Prefill fields"
          />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(SignedDataModal);
